import React, { createContext, useContext, useState, useCallback } from 'react';

const DataContext = createContext(null);

// ─── Seed data ────────────────────────────────────────────────────────────────
const SEED = {
  projects: [
    { id: 1, name: 'Al Rayyan Tower – Phase 1', client: 'Al Rayyan Development', status: 'Active',
      progress: 42, budget: 12400000, spent: 5230000, start: '2025-01-15', end: '2026-09-30',
      description: 'Mixed-use 18-storey tower in Beirut CBD.', contractRef: 'ART-MAIN-01' },
    { id: 2, name: 'Marina Promenade Infrastructure', client: 'City Works Dept', status: 'Active',
      progress: 68, budget: 4800000, spent: 3290000, start: '2024-08-01', end: '2025-12-31',
      description: 'Coastal promenade civil works and MEP.', contractRef: 'MPI-MAIN-01' },
    { id: 3, name: 'Hilltop Villas Complex', client: 'Private Developer', status: 'On Hold',
      progress: 15, budget: 8200000, spent: 1180000, start: '2025-06-01', end: '2027-03-01',
      description: '12-unit luxury villa complex.', contractRef: 'HVC-MAIN-01' },
  ],
  wbs: [
    { id:'w1', projectId:1, code:'1.0', name:'Site Preparation', parent:null, progress:100, start:'2025-01-15', end:'2025-02-28', duration:44, color:'#3b82f6' },
    { id:'w2', projectId:1, code:'2.0', name:'Foundations',       parent:null, progress:100, start:'2025-03-01', end:'2025-05-15', duration:75, color:'#8b5cf6' },
    { id:'w3', projectId:1, code:'2.1', name:'Pile Driving',      parent:'w2', progress:100, start:'2025-03-01', end:'2025-04-10', duration:40, color:'#7c3aed' },
    { id:'w4', projectId:1, code:'2.2', name:'Raft Slab',         parent:'w2', progress:100, start:'2025-04-11', end:'2025-05-15', duration:34, color:'#7c3aed' },
    { id:'w5', projectId:1, code:'3.0', name:'Structural Works',  parent:null, progress:55,  start:'2025-05-16', end:'2025-12-31', duration:229, color:'#0ea5e9' },
    { id:'w6', projectId:1, code:'3.1', name:'Ground Floor Columns', parent:'w5', progress:100, start:'2025-05-16', end:'2025-06-30', duration:45, color:'#0284c7' },
    { id:'w7', projectId:1, code:'3.2', name:'Floors 1–5 Structure', parent:'w5', progress:80, start:'2025-07-01', end:'2025-09-30', duration:91, color:'#0284c7' },
    { id:'w8', projectId:1, code:'3.3', name:'Floors 6–12 Structure', parent:'w5', progress:30, start:'2025-10-01', end:'2025-12-31', duration:91, color:'#0284c7' },
    { id:'w9', projectId:1, code:'4.0', name:'MEP Rough-In',      parent:null, progress:20,  start:'2025-09-01', end:'2026-04-30', duration:241, color:'#f59e0b' },
    { id:'w10',projectId:1, code:'5.0', name:'Finishes',          parent:null, progress:0,   start:'2026-03-01', end:'2026-09-30', duration:213, color:'#10b981' },
  ],
  incidents: [
    { id:1, projectId:1, date:'2025-11-12', ref:'INC-001', type:'Near Miss', severity:'Medium',
      description:'Worker slipped on wet concrete near B3 formwork. No injury.', location:'Level 3 – Grid B3',
      status:'Closed', reportedBy:'Khalil A. – Foreman', action:'Anti-slip tape installed, safety briefing held' },
    { id:2, projectId:1, date:'2025-11-20', ref:'INC-002', type:'Injury', severity:'High',
      description:'Minor laceration on right hand from rebar cutting. First aid administered.', location:'Rebar yard',
      status:'Open', reportedBy:'Safety Officer', action:'Investigation pending' },
    { id:3, projectId:1, date:'2025-12-01', ref:'INC-003', type:'Property Damage', severity:'Low',
      description:'Crane swing grazed perimeter hoarding. No structural damage.', location:'North crane path',
      status:'Closed', reportedBy:'Crane Operator', action:'Swing radius re-marked' },
  ],
  mrqs: [
    { id:1, projectId:1, ref:'MRQ-001', date:'2025-11-10', item:'Ready-Mix Concrete C35', qty:180, unit:'m³',
      specRef:'STR-C35-01', wbs:'3.2', priority:'Urgent', status:'Approved', supplier:'CemCo Lebanon',
      deliveryDate:'2025-11-15', cost:54000, notes:'' },
    { id:2, projectId:1, ref:'MRQ-002', date:'2025-11-18', item:'Deformed Rebar Ø16mm', qty:12, unit:'tons',
      specRef:'STR-RB-016', wbs:'3.2', priority:'Normal', status:'Pending', supplier:'', deliveryDate:'', cost:0, notes:'' },
    { id:3, projectId:1, ref:'MRQ-003', date:'2025-11-25', item:'Formwork Panels 18mm', qty:400, unit:'m²',
      specRef:'TEMP-FW-01', wbs:'3.3', priority:'Normal', status:'Ordered', supplier:'BuildForm Co.',
      deliveryDate:'2025-12-05', cost:18000, notes:'' },
    { id:4, projectId:1, ref:'MRQ-004', date:'2025-12-02', item:'Waterproofing Membrane', qty:600, unit:'m²',
      specRef:'WP-MEM-02', wbs:'2.2', priority:'Low', status:'Draft', supplier:'', deliveryDate:'', cost:0, notes:'' },
  ],
  vos: [
    { id:1, projectId:1, ref:'VO-001', date:'2025-10-15', title:'Additional Excavation – South Sector',
      scope:'Extra 850m³ excavation due to unexpected rock layer.', contractRef:'ART-MAIN-01',
      category:'Client Variation', status:'Approved', value:38500, submittedBy:'PM – Rami H.', approvedBy:'Client Rep', notes:'' },
    { id:2, projectId:1, ref:'VO-002', date:'2025-11-05', title:'Design Change – Staircore Width',
      scope:'Increase staircore width from 1.2m to 1.5m per architect Rev.4.',contractRef:'ART-MAIN-01',
      category:'Design Change', status:'Under Review', value:14200, submittedBy:'PM – Rami H.', approvedBy:'', notes:'' },
    { id:3, projectId:1, ref:'VO-003', date:'2025-11-22', title:'Upgrade Column Concrete C40→C50',
      scope:'Structural engineer upgrade for high-load columns L3–L6.',contractRef:'ART-MAIN-01',
      category:'Engineering Change', status:'Pending', value:22800, submittedBy:'Struct. Eng.', approvedBy:'', notes:'' },
  ],
  costs: [
    { id:1, projectId:1, category:'Structural Works', budgeted:4200000, committed:3800000, actual:2100000, wbs:'3.0' },
    { id:2, projectId:1, category:'Foundations',      budgeted:1800000, committed:1800000, actual:1800000, wbs:'2.0' },
    { id:3, projectId:1, category:'Site Preparation', budgeted:320000,  committed:318000,  actual:318000,  wbs:'1.0' },
    { id:4, projectId:1, category:'MEP',              budgeted:2400000, committed:800000,  actual:210000,  wbs:'4.0' },
    { id:5, projectId:1, category:'Finishes',         budgeted:2800000, committed:0,       actual:0,       wbs:'5.0' },
    { id:6, projectId:1, category:'Preliminaries',    budgeted:880000,  committed:880000,  actual:602000,  wbs:'0.0' },
  ],
  docs: [
    { id:1, projectId:1, ref:'DOC-001', date:'2025-09-01', title:'Structural Design Drawings – Rev 3',
      category:'Drawing', discipline:'Structural', status:'Approved', rev:'C', issuedBy:'Struct. Eng. Office', file:'STR-DWG-REV3.pdf', notes:'' },
    { id:2, projectId:1, ref:'DOC-002', date:'2025-10-14', title:'MEP Coordination Drawing L1–L5',
      category:'Drawing', discipline:'MEP', status:'For Review', rev:'A', issuedBy:'MEP Consultant', file:'MEP-COORD-L1-5.pdf', notes:'' },
    { id:3, projectId:1, ref:'DOC-003', date:'2025-11-01', title:'Concrete Mix Design – C35',
      category:'Submittal', discipline:'Structural', status:'Approved', rev:'B', issuedBy:'Materials Lab', file:'CONC-MIX-C35.pdf', notes:'' },
    { id:4, projectId:1, ref:'DOC-004', date:'2025-11-20', title:'Method Statement – Prestress Slab',
      category:'Method Statement', discipline:'Structural', status:'Under Review', rev:'A', issuedBy:'Main Contractor', file:'MS-PRESTRESS.pdf', notes:'' },
  ],
  ipcs: [
    { id:1, projectId:1, ref:'IPC-001', subcontractor:'Al Nour MEP Contractors', wbs:'4.0', period:'Oct 2025',
      submittedDate:'2025-11-05', certifiedDate:'2025-11-18', claimed:185000, certified:162000,
      retention:16200, netPayable:145800, status:'Certified', notes:'' },
    { id:2, projectId:1, ref:'IPC-002', subcontractor:'SteelPro Rebar Works', wbs:'3.0', period:'Oct 2025',
      submittedDate:'2025-11-03', certifiedDate:'2025-11-15', claimed:310000, certified:310000,
      retention:31000, netPayable:279000, status:'Paid', notes:'' },
    { id:3, projectId:1, ref:'IPC-003', subcontractor:'Al Nour MEP Contractors', wbs:'4.0', period:'Nov 2025',
      submittedDate:'2025-12-05', certifiedDate:'', claimed:220000, certified:0,
      retention:0, netPayable:0, status:'Under Review', notes:'' },
  ],
  dailyReports: [
    { id:1, projectId:1, date:'2025-12-01', weather:'Sunny 22°C', wbs:'3.2',
      activities:'Poured columns L6 Grid A–D. Rebar fixing ongoing Level 7.',
      manpower:{ labor:34, supervisor:3, engineer:2 },
      equipment:'Tower Crane TC1, Concrete Pump P1, Vibrator ×3',
      materials:'85m³ C35 Concrete, 2.4T Rebar Ø12', issues:'None', submittedBy:'Jad M. – Site Eng.' },
    { id:2, projectId:1, date:'2025-11-30', weather:'Partly Cloudy 19°C', wbs:'3.2',
      activities:'Formwork fixing Level 7 East bay. Material delivery inspection.',
      manpower:{ labor:28, supervisor:2, engineer:2 },
      equipment:'Tower Crane TC1, Forklift FL1',
      materials:'180 Formwork panels 18mm', issues:'Formwork delivery 2hrs late', submittedBy:'Jad M. – Site Eng.' },
  ],
};

function loadData() {
  try {
    const saved = localStorage.getItem('cp_data');
    return saved ? JSON.parse(saved) : SEED;
  } catch { return SEED; }
}

function saveData(data) {
  try { localStorage.setItem('cp_data', JSON.stringify(data)); } catch {}
}

export function DataProvider({ children }) {
  const [data, setDataRaw] = useState(loadData);
  const [activeProjectId, setActiveProjectId] = useState(() => {
    const saved = localStorage.getItem('cp_active_project');
    return saved ? parseInt(saved) : 1;
  });

  const setData = useCallback((updater) => {
    setDataRaw(prev => {
      const next = typeof updater === 'function' ? updater(prev) : updater;
      saveData(next);
      return next;
    });
  }, []);

  const activeProject = data.projects.find(p => p.id === activeProjectId) || data.projects[0];

  const switchProject = (id) => {
    setActiveProjectId(id);
    localStorage.setItem('cp_active_project', id);
  };

  // ── Generic CRUD helpers ─────────────────────────────────────────────────
  const addItem    = (key, item) => setData(d => ({ ...d, [key]: [...d[key], { ...item, id: Date.now() }] }));
  const updateItem = (key, item) => setData(d => ({ ...d, [key]: d[key].map(i => i.id === item.id ? item : i) }));
  const deleteItem = (key, id)   => setData(d => ({ ...d, [key]: d[key].filter(i => i.id !== id) }));
  const upsert     = (key, item) => item.id && data[key].some(i => i.id === item.id) ? updateItem(key, item) : addItem(key, item);

  // ── Export / Import ──────────────────────────────────────────────────────
  const exportJSON = () => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `constructpro-export-${new Date().toISOString().split('T')[0]}.json`;
    a.click();
  };

  const importJSON = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => {
      try {
        const parsed = JSON.parse(e.target.result);
        setData(parsed);
        resolve();
      } catch { reject(new Error('Invalid JSON file.')); }
    };
    reader.readAsText(file);
  });

  const resetToSeed = () => { setData(SEED); };

  return (
    <DataContext.Provider value={{
      data, activeProject, activeProjectId, switchProject,
      addItem, updateItem, deleteItem, upsert,
      exportJSON, importJSON, resetToSeed,
    }}>
      {children}
    </DataContext.Provider>
  );
}

export function useData() { return useContext(DataContext); }
